import React, { useState, useMemo, useEffect } from "react";
// react plugin used to create DropdownMenu for selecting items
import Select from 'react-select'
import './SelectInstitution.css'

const SelectInstitution = (props) => {
  const [value, setValue] = useState()
  const [options, setOptions] = useState([])
  const credential = props.credential
  const setCredential = props.setCredential

  const changeHandler = item => {
    setValue(item)
    credential['institution'] = {_id: item.value}
    setCredential(credential)
  }

  useEffect(() => {

    let alternatives = []

    props.selectOptions?.map((item) => {
      let target = { value: item._id, label: item.name }

      alternatives.push(target)

      if (item._id == props.institutionId)
        setValue(target)

    })

    setOptions(alternatives)

  }, [props.selectOptions, props.institutionId])

  return (
    <div >
      <Select
        className="form-control-alternative"
        isDisabled={props.formDisabled}
        options={options}
        value={value}
        id="input-institution"
        classNamePrefix="selectInstitution"
        onChange={changeHandler}
      />
    </div>
  );

}

export default SelectInstitution;
